import { createFileRoute } from "@tanstack/react-router"
import { TenantsPage } from "@/admin"

export const Route = createFileRoute("/(user)/admin/tenants")({
  component: RouteComponent,
})

function RouteComponent() {
  return <TenantsPage />
}
